import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  expandButton: {
    overflow: 'visible',
    '&&': {
      boxShadow: 'none',
    },

    height: 'auto',
    padding: 0,

    fontWeight: 600,
    fontSize: theme.spacing(4),
    lineHeight: theme.spacing(6),

    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));
